import React from 'react';
import { Card, CardContent } from './ui/card';
import { Building2, Landmark, Shield, Globe } from 'lucide-react';

const BenefactorsSection = () => {
  const benefactorCategories = [
    {
      id: 1,
      title: 'Corporate Agencies',
      icon: Building2,
      description: 'Leading corporate partners supporting our mission'
    },
    {
      id: 2,
      title: 'Public Agencies',
      icon: Landmark,
      description: 'Public sector collaborators and supporters'
    },
    {
      id: 3,
      title: 'Government Ministries/Departments',
      icon: Shield,
      description: 'Government bodies partnering for social change'
    },
    {
      id: 4,
      title: 'International & National Development Agencies',
      icon: Globe,
      description: 'Global and national development organizations'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Our Benefactors
          </h2>
          <div className="w-24 h-1 bg-orange-600 mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefactorCategories.map((category) => {
            const Icon = category.icon;
            return (
              <Card
                key={category.id}
                className="border-none shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group"
              >
                <CardContent className="p-8 text-center">
                  <div className="mb-6 flex justify-center">
                    <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center group-hover:bg-orange-600 transition-colors duration-300">
                      <Icon className="text-orange-600 group-hover:text-white transition-colors duration-300" size={40} />
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-gray-800 mb-3">
                    {category.title}
                  </h3>
                  <p className="text-gray-600">{category.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BenefactorsSection;